import React from 'react';
import {
    InfoWrapper,
    TextWrapper,
    TopLine,
    Heading,
    Subtitle,
    BtnWrap,
    ImgWrap,
    Img,
    Card,
    BtnLink,
    FormH4,
    SelectButton
} from './SlateDisplayElements';

const SlateCard = ({ slate, handleSlateSelect }) => {
    const formattedDateTime = new Date(slate.OperatorStartTime).toLocaleString([], {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
    });

    return (
        <>
            <Card>
                {/* <ImgWrap>
                    <Img src={app.img} alt={app.alt} />
                </ImgWrap> */}
                <TextWrapper>
                    <TopLine>{slate.Operator}</TopLine>
                    <TopLine>{slate.OperatorName}</TopLine>
                    <FormH4>{formattedDateTime}</FormH4>
                    <FormH4>Games: {slate.NumberOfGames}</FormH4>
                    <FormH4 errorText={slate.RemovedByOperator == true}>{slate.RemovedByOperator ? ("Removed") : ""}</FormH4>
                    {/* <BtnWrap>
                            <BtnLink
                                offset={-80}
                                primary={true}
                                dark={false}
                                dark2={false}
                            >
                                Add
                            </BtnLink>
                        </BtnWrap> */}
                </TextWrapper>
                <SelectButton disabled={slate.RemovedByOperator == true} dark={false} primary={slate.RemovedByOperator == false} big={false} fontBig={false} onClick={handleSlateSelect(slate)}>Select</SelectButton>
            </Card>
        </>
    );
};

export default SlateCard;
